// Bootstrap Vue Nextのコアプラグインと個別コンポーネントをインポート
import { createBootstrap } from 'bootstrap-vue-next'
import {
  BContainer,
  BRow,
  BCol,
  BAlert,
  BCard,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BInputGroup,
  BInputGroupText,
  BFormSelect,
  BFormInput,
  BFormInvalidFeedback,
  BListGroup,
  BListGroupItem,
  BBadge,
  BCollapse,
  BCardText,
  BButton,
  BModal,
  BSpinner,
  BOverlay,
  BFormCheckbox,
  BTab,
  BTabs,
  BNav,
  BNavItem,
  BPagination,
  BTable,
  BTableSimple,
  BTr,
  BTh,
  BTd,
  BTbody,
  BThead,
  BCardGroup,
  BAvatar
} from 'bootstrap-vue-next'

// CSSインポート
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

export default function (app) {
  // Bootstrap Vue Nextのコアプラグインを初期化（DIプロバイダーを含む）
  app.use(createBootstrap())

  // 個別にコンポーネントを登録
  app.component('BContainer', BContainer)
  app.component('BRow', BRow)
  app.component('BCol', BCol)
  app.component('BAlert', BAlert)
  app.component('BCard', BCard)
  app.component('BForm', BForm)
  app.component('BFormGroup', BFormGroup)
  app.component('BFormRadioGroup', BFormRadioGroup)
  app.component('BFormRadio', BFormRadio)
  app.component('BInputGroup', BInputGroup)
  app.component('BInputGroupText', BInputGroupText)
  app.component('BFormSelect', BFormSelect)
  app.component('BFormInput', BFormInput)
  app.component('BFormInvalidFeedback', BFormInvalidFeedback)
  app.component('BListGroup', BListGroup)
  app.component('BListGroupItem', BListGroupItem)
  app.component('BBadge', BBadge)
  app.component('BCollapse', BCollapse)
  app.component('BCardText', BCardText)
  app.component('BButton', BButton)
  app.component('BModal', BModal)
  app.component('BSpinner', BSpinner)
  app.component('BOverlay', BOverlay)
  app.component('BFormCheckbox', BFormCheckbox)
  app.component('BTab', BTab)
  app.component('BTabs', BTabs)
  app.component('BNav', BNav)
  app.component('BNavItem', BNavItem)
  app.component('BTable', BTable)
  app.component('BTableSimple', BTableSimple)
  app.component('BPagination', BPagination)
  app.component('BTr', BTr)
  app.component('BTh', BTh)
  app.component('BTd', BTd)
  app.component('BTbody', BTbody)
  app.component('BThead', BThead)
  app.component('BCardGroup', BCardGroup)
  app.component('BAvatar', BAvatar)
}
